import React, { useContext } from "react";
import { DashboardContext } from "../../../contexts/DashboardContext";
import useDashboardQuery from "../../../hooks/useDashboardQuery";
import TextAnswer from "../dashboard-query-answer/TextAnswer";
import InlineTextQueryContainer from "../dashboard-query-container/InlineTextQueryContainer";

const FoundedQuery: React.FC<{}> = () => {
    const { isPublicView } = useContext(DashboardContext);
    const { queryAnswer, updateQuery } = useDashboardQuery('Founded');

    return (<>
        <InlineTextQueryContainer
            queryAnswer={queryAnswer}
            displayMenu={!isPublicView}
            onEdit={updateQuery}>
            <TextAnswer answeredQuestion={queryAnswer.answeredQuestion} noAnswer="Add founding date ..." />
        </InlineTextQueryContainer>
    </>);
}

export default FoundedQuery;
